import axios from "axios";
import http, { baseUrl } from "./config";

export const login = async (payload: {
  username: string;
  password: string;
}) => {
  return await http.post(`/pc/login`, payload);
};

export const loginWithWebguid = async (payload: {
  username: string;
  password: string;
  guid:string
}) => {
  return await http.post(`/ibile/auth`, payload);
};

export const validatePIN = async (payload: { guid: string }) => {
  return await http.post(`/ibile/validate`, payload);
};

export const makePayment = async (
  payload: {
    parentGuid: string;
    amountPaid: number;
  },
  access_token: string
) => {
  return await axios.post(`${baseUrl}/ibile/payment`, payload, {
    headers: {
      "Content-Type": "application/json",
      "X-AUTH": access_token ?? "",
    },
  });
};
